// import './css/service-edit.css';

import React from 'react';
import moment from 'moment';

import DatePicker from 'react-datepicker';

import API from 'service/api';
import Util, { Data } from 'service/util';

import Form from 'component/Form';
import ServiceWeekdayPicker from 'component/service/ServiceWeekdayPicker';
import PopMessage from 'component/pop-msg/PopMessage';
import LocationSelect from 'component/dropdown/LocationSelect';
import ModalScreen from 'component/ModalScreen';

class EditServiceModal extends React.Component
{
  constructor(props)
  {
    super(props);
    // clone service as state
    let service = {};
    Object.keys(props.service).forEach(key => service[key] = props.service[key]);
    service.ori_dtm = props.service.start_dtm;
    // set state
    this.state = {
      error: '',
      service,
      cur_worker: service?.worker || 0,
    };

    this.setLocation = this.setLocation.bind(this);
    this.setWeekdays = this.setWeekdays.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }

  setService(key, value)
  {
    this.state.service[key] = value;
    this.forceUpdate();
  }
  setPlan(plan)
  {
    let s = this.state.service;
    s.srv_plan = plan;
    switch (plan) {
      case 'A':
        s.weekday1 = 0;
        s.weekday2 = 0;
        s.weekday3 = 0;
        s.waxing   = true;
        break;
      case 'B':
        s.waxing   = true;
        break;
      case 'C':
        s.weekday2 = 0;
        s.weekday3 = 0;
        s.waxing   = false;
        break;
    }
    this.forceUpdate();
  }
  setWeekdays(d1, d2, d3)
  {
    const { service } = this.state;
    service.weekday1 = d1;
    service.weekday2 = d2;
    service.weekday3 = d3;
    this.setState({ service });
  }
  setLocation(dis, loc)
  {
    const { service } = this.state;
    service.srv_dis = dis;
    service.srv_loc = loc;
    this.setState({ service });
  }

  get minEndDate()
  {
    let refDate = new Date(moment(this.state.service.start_dtm).valueOf());
    refDate.setHours(24,0,0,0);
    return refDate;
  }

  submitModal(e)
  {
    e.preventDefault();
    e.stopPropagation();

    let service = {...this.state.service};
    service.ori_dtm   = Util.ShortDate(service.ori_dtm);
    service.reg_dtm   = Util.ShortDate(service.reg_dtm);
    service.start_dtm = Util.ShortDate(service.start_dtm);
    service.end_dtm   = Util.ShortDate(service.end_dtm)||null;

    API.editServiceRecord(service).then(resp =>
    {
      if (resp.success) {
        // copy
        Object.keys(this.props.service).forEach(key =>
          this.props.service[key] = this.state.service[key]
        );
        PopMessage.show('已成功修改記錄。', '成功', 'success');
        this.props.onUpdatedService(resp.msg);
        this.props.closeModal();
      } else {
        PopMessage.show(resp.msg, '失敗', 'danger');
      }
    });

    return false;
  }

  render()
  {
    const s = this.state.service;
    const v = this.props.vehicle;
    return (
      <ModalScreen className="sem sem-edit" show={true}
        title={`修改車輛服務 - ${v.cd_license}`}
        onClose={this.props.closeModal}>
        <Form className="sem-form" onSubmit={this.submitModal}>
          <p className="message yellow">
            修改預定的服務變更，此動作只修改目前選取的資料列，並不會產生新的資料列。
          </p>

          <label className="field">
            <strong>服務開始日</strong>
            <DatePicker selected={s.start_dtm} onChange={d=>this.setService('start_dtm', d)}
                        dateFormat="yyyy-MM-dd" minDate={this.props.min_dtm} />
          </label>
          <label className="field">
            <strong>服務結束日</strong>
            <DatePicker selected={s.end_dtm} onChange={d=>this.setService('end_dtm', d)}
                        dateFormat="yyyy-MM-dd" minDate={this.minEndDate} />
          </label>

          <div className="split-3">
            <label className="field">
              <strong>公司</strong>
              <select value={s.company} onChange={e=>this.setService('company', e.target.value)}>
                { Data.company.map(com =>
                  <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                )}
              </select>
            </label>
            <label className="field">
              <strong>計劃</strong>
              <select value={s.srv_plan} onChange={e=>this.setPlan(e.target.value)}>
                { Data.plan.map(p =>
                  <option key={`plan-${p}`} value={p}>{ p }</option>
                )}
              </select>
            </label>
            <label className="field">
              <strong>服務日</strong>
              <ServiceWeekdayPicker plan={s.srv_plan}
                d1={s.weekday1} d2={s.weekday2} d3={s.weekday3}
                onChange={this.setWeekdays} />
            </label>
          </div>

          <div className="split-3">
            <LocationSelect labelClass="field"
              district={s.srv_dis}
              location={s.srv_loc}
              onUpdate={this.setLocation}
            />
          </div>
          <div className="split-3">
            <label className="field">
              <strong>車種</strong>
              <select className="nc-vhtype" value={s.vh_type}
                      onChange={e=>this.setService('vh_type', parseInt(e.target.value, 10))}>
                { Data.vtype.map(t =>
                  <option key={`vt-${t.id}`} value={t.id}>{t.id} - {t.desc}</option>
                )}
              </select>
            </label>
            <label className="field">
              <strong>打蠟</strong>
              <input type="checkbox" checked={s.waxing}
                    onChange={e=>this.setService('waxing', e.target.checked)} />
            </label>
          </div>
          <div className="split-2">
            <label className="field">
              <strong>樓層</strong>
              <input type="text" placeholder="車輛停泊樓層" value={s.srv_floor}
                      onChange={e=>this.setService('srv_floor', e.target.value)} />
            </label>
            <label className="field">
              <strong>車位</strong>
              <input type="text" placeholder="車位號碼" value={s.srv_psn}
                      onChange={e=>this.setService('srv_psn', e.target.value)} />
            </label>
          </div>
          <div className="split-3">
            <label className="field">
              <strong>月費</strong>
              <input type="number" placeholder="價錢" value={s.fee} required
                      onChange={e=>this.setService('fee', parseFloat(e.target.value) )} />
            </label>
            <label className="field">
              <strong>附加項目</strong>
              <input type="text" placeholder="如輪抹車" value={s.rotation}
                     onChange={e=>this.setService('rotation', e.target.value )} />
            </label>
            <label className="field">
              <strong>附加費</strong>
              <input type="number" placeholder="每月固定收費" value={s.extra_fee} required
                     onChange={e=>this.setService('extra_fee', parseFloat(e.target.value) )} />
            </label>
          </div>
          <label className="field">
            <strong>負責工人</strong>
            <select value={s.worker} required
                    onChange={e=>this.setService('worker', parseInt(e.target.value, 10) )}>
              <option value={Data.defaultWorkerId}>公司預設 (ID={Data.defaultWorkerId})</option>
              { Data.wkrloc[`${s.srv_dis}${s.srv_loc}`]?.map(w =>
                <option key={`wkr-${w.uid}`} value={w.uid}>{w.cd} - {w.name}</option>
              )}
              <option value={this.state.cur_worker}>當前工人 (ID={this.state.cur_worker})</option>
            </select>
          </label>

          <div className="error-msg">
            { this.state.error }
          </div>
          <div className="action-panel">
            <button className="btn grey" type="button"
                    onClick={e=>this.props.closeModal()}>關閉</button>
            <button id="btn-submit" className="btn blue" >確定</button>
          </div>
        </Form>
      </ModalScreen>
    );
  }

}


export default EditServiceModal;